import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { Observable, Subscription, forkJoin, of } from "rxjs";
import { BoydRewardsService } from "src/app/services/boyd-rewards/boyd-rewards.service";
import { ConfigService } from "src/app/services/config/config.service";
import { EventsService } from "src/app/services/event/event.service";
import { GameHubControllerService } from "src/app/services/gameHub/game-hub-controller";
import { GamesService } from "src/app/services/lobby/games.service";
import { LobbyService } from "src/app/services/lobby/lobby.service";
import { RewardsService } from "src/app/services/rewards/rewards.service";
import { Navigator } from "../menu/navigator";
import { BonusService } from "src/app/services/bonus/bonus.service";
import { LobbyNavigator } from "src/app/services/lobby/lobby-navigator.service";
import { LoadingController } from "@ionic/angular";

@Component({
  selector: "app-games-bonus-free-spins",
  templateUrl: "./games-bonus-free-spins.component.html",
  styleUrls: ["./games-bonus-free-spins.component.scss"],
})
export class GamesBonusFreeSpinsComponent implements OnInit, OnDestroy {
  @Input() freeSpinsEmpty = false; 
  public gamesWithBonus: any;
  public imagePath = "";
  public numOfGamesThreshold = 8;
  private gameSubscriptions: Subscription;
  public internalGames: any[] = [];
	public loading: any;
  public externalLoadingDone: boolean = false;
  public internalLoadingDone: boolean = false;
  public showFreeSpinCampaignName: boolean;
  public displayEmpty: Boolean = false; 
  
  constructor(
    private gameService: GamesService,
    private boydRewardsService: BoydRewardsService,
    private gameHubControllerService: GameHubControllerService,
    private lobbyService: LobbyService,
    private readonly config: ConfigService,
    private rewardsService: RewardsService,
    private navigator:Navigator,
    private events:EventsService,
    private gameHubController:GameHubControllerService,
    private bonusService: BonusService,
    private lobbyNavigator: LobbyNavigator,
		public loadingController: LoadingController
  ) {
    this.imagePath = this.lobbyService.galleryImagePath;
    this.showLoading();
    this.getExternalBonusFreeSpins();
    this.getInternalBonusFreeSpins();
  }

  ngOnInit() {
    this.numOfGamesThreshold = !isNaN(Number(this.config.getConfig().FEATURE_GAME_BONUS_FREE_NUMBER_THRESHOLD)) ? Number(this.config.getConfig().FEATURE_GAME_BONUS_FREE_NUMBER_THRESHOLD) : 8;
    this.showFreeSpinCampaignName = this.config.getConfig().FEATURE_SHOW_FREE_SPIN_CAMPAIGN_NAME === '1' ? true : false;
  }

  private getInternalBonusFreeSpins() {
    this.rewardsService
      .getInternalFreeSpins()
      .subscribe((response) => {

        if (response.result == 1) {
          response.payload.forEach(element => {
            let numSpins = parseInt(element.numFreeSpins);
            let numLines = parseInt(element.numPaylines);
            const promoId = element.campaignId;
            const promoName = element.campaignName;
            let betPerLine = Math.round(parseFloat(element.betPerLine) * 100);
            let currency = element.type;
            let expiryDate = element.expiryDate;

            let bonusFreeSpin = { numSpins: numSpins, numLines: numLines,campaignId: promoId,campaignName: promoName, bet: { amount: betPerLine, currency: currency }, expiryDate: expiryDate, games: [] }
            if (element.launch_ids != "any") {
              let launch_ids = element.launch_ids.split(",");
              let game_type_ids = element.game_type_ids.split(",");
              let images = element.imagenames.split(",");
              let names = element.game_names.split(",");

              for (let i = 0; i < launch_ids.length; i++) {
                let game = { launch_id: launch_ids[i], game_type_id: game_type_ids[i], game_name: names[i], imagename: images[i] }
                bonusFreeSpin.games.push(game);
              }

            }

            this.internalGames.push(bonusFreeSpin);
            this.checkGameListEmpty();
          });
        }

        
        this.loadingDoneInternal();
      });
  }


  private getExternalBonusFreeSpins() {
    this.boydRewardsService
      .callGetExternalGamesBonusSpins()
      .subscribe((resp) => {
        if(resp.result == 1) {
        this.gamesWithBonus = resp.payload.freeBetInfo;


        let parallelObservableArray: Observable<any>[] = [];
        for (let vendor in this.gamesWithBonus) {
          for (let game of this.gamesWithBonus[vendor]) {
            // Don't filter if number of games is not more than threshold number. In that case we don't need image. Hence better performance.
            if (!(game.games?.length > this.numOfGamesThreshold)) {
              parallelObservableArray.push(
                this.gameService.filterGamesWithListBasedOnIds(
                  game.games
                )
              );
            } else {
              parallelObservableArray.push(of([]));
            }
          }
        }

        // Run Parellelly to get game details which so that game images can be loaded
        this.gameSubscriptions = forkJoin(parallelObservableArray).subscribe(
          (data) => {
            let vendorIndex = 0;
            let gameIndex = 0;
            for (const vendor in this.gamesWithBonus) {
              for (let game of this.gamesWithBonus[vendor]) {
                game["gameDataArray"] = data[gameIndex];
                gameIndex++;
              }
              vendorIndex++;
            }
          }
        );
      this.loadingDoneExternal();
      this.checkGameListEmpty();
      }  
    });
  }

  protected launchGameWithData(gameData) {
    // console.log(" Game data ", this.gameService.getGameById(1418));
    // const gameData = this.gameService.getGameById(gameId);
    this.closeGame();
    this.onFreeSpinModalCancel();
    setTimeout(() => {
      this.gameHubControllerService.launchCasinoGame(gameData);
    }, 1000);
  }


  onFreeSpinModalCancel() {
    this.navigator.dismiss();
  }

  closeGame() {
    this.events.publish("event:game:close");
    this.gameHubController.killAllInstances();
  }

  protected launchGameWithId(gameId) {
    this.closeGame();
    const gameData = this.gameService.getGameById(gameId);
    this.onFreeSpinModalCancel();
    setTimeout(() => {
      this.gameHubControllerService.launchCasinoGame(gameData);
    }, 1000);
  }

  goBackToPromotion(gamesInfo) {
    this.bonusService.setPromoDetailInfo(gamesInfo.campaignId);
    this.navigator.dismissAll('');
    this.lobbyNavigator.navigateToPromotionsWebOrMobile();
  }

  ngOnDestroy(): void {
    if (this.gameSubscriptions) {
      this.gameSubscriptions.unsubscribe();
    }
  }

  loadingDoneExternal() {
    this.externalLoadingDone = true;
    this.loadingDone();
  }
  
  loadingDoneInternal() {
    this.internalLoadingDone = true;
    this.loadingDone();
  }

  loadingDone() {
    if(this.internalLoadingDone && this.externalLoadingDone) this.loading.dismiss();
  }

  async showLoading() {
		this.loading = await this.loadingController.create({
			message: 'Loading...',
			duration: 10000
		});

		this.loading.present();
	}

  checkGameListEmpty() {
    if (!this.internalGames.length && Object.keys(this.gamesWithBonus).length == 0 && this.freeSpinsEmpty) {
      this.displayEmpty = true
    }
  }
}
